<template>
  <ol class="breadcrumb">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="breadcrumb-item">
      <span
        v-if="isLast(index)"
        class="btn btn-link p-0 disabled">{{ item.label }}</span>
      <button
        v-else
        :disabled="item.disabled"
        class="btn btn-link p-0"
        @click.prevent="handleActionOrLink(item)">
        <component
          v-if="item.component"
          :is="item.component"
          v-bind="item.props"
        />
        <template v-else>{{ item.label }}</template>
      </button>
    </li>
    <a v-if="refreshable" href="float-right" @click.prevent="$emit('refresh')">
      <i class="fa fa-fw fa-refresh"></i>
    </a>
    <slot></slot>
  </ol>
</template>

<script>
export default {
  props: {
    refreshable: {
      type: Boolean,
      default: false
    },

    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.items.length - 1
    },

    handleActionOrLink(item) {
      if (item.confirm) {
        if (!confirm(item.confirm)) {
          return;
        }
      }

      if (item.link) {
        this.handleLink(item.link);
        return;
      }

      if (item.action) {
        item.action();
        return;
      }

      console.warn('No link/action specified');
    },

    handleLink(link) {
      this.$router.push(link);
      return;
      //console.log('To be implemented: handleLink: ', link, this.$router);
    }
  }
}
</script>
